import { Box } from '@mui/material';
import { ChipsContainer } from 'app/ComponentLibrary/Filter';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { notificationFilterName } from '../../Notification/Filters/utils';
import { TabTitle } from '../../PerformanceReport';
import Filters from './Filters';
import { createFilterChips } from './helper';

const FilterWrapper = ({ selectedFilterValue, onFilterChange, title, defaultChip, defaultValues, filterSpec }) => {
  const formMethods = useForm({ defaultValues });
  const { t } = useTranslation();

  const { handleSubmit, getValues, setValue } = formMethods;

  const [chips, setChips] = useState<any>(createFilterChips(selectedFilterValue, t, title));

  useEffect(() => {
    setChips(createFilterChips(selectedFilterValue, t, title));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterValue]);

  const onApplyFilter = values => {
    const chips = createFilterChips(values, t, title);
    setChips(chips);
    onFilterChange(values);
  };

  const handleChipDelete = (field, chip) => {
    const chipsTemp = JSON.parse(JSON.stringify(chips[field]));
    if (title === TabTitle.communication && field === notificationFilterName.status) {
      const values: any = [];
      chipsTemp
        .filter(values => values.label !== chip.label)
        .map(val => {
          if (values.length === 0) {
            values.push(val.value[0]);
          } else {
            const index = values.findIndex(value => value.name === val?.value[0]?.name);
            if (index !== -1) {
              values[index].children.push(val.value[0].children[0]);
            } else {
              values.push(val.value[0]);
            }
          }
        });
      setValue(field, values);
    } else {
      setValue(
        field,
        chipsTemp
          .filter(values => values.label !== chip.label)
          .map(value => ({
            id: value.value,
            name: value.label,
            value: value.value,
          })),
      );
    }
    onApplyFilter(getValues());
  };

  const onReset = () => {
    setChips(defaultChip);
    onFilterChange(defaultValues);
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onApplyFilter)}>
        <Filters
          selectedValue={selectedFilterValue}
          chips={chips}
          onReset={onReset}
          defaultValues={defaultValues}
          title={title}
          filterSpec={filterSpec}
        />
        <Box marginTop={'12px'} marginBottom={'10px'}>
          <ChipsContainer chips={chips} onDelete={(field, chip) => handleChipDelete(field, chip)} onClick={() => {}} />
        </Box>
      </form>
    </FormProvider>
  );
};

export default FilterWrapper;
